export default {
    ERROR_OPEN_MODAL: 'ERROR::OPEN_MODAL',
    ERROR_CLOSE_MODAL: 'ERROR::CLOSE_MODAL'
};



// WEBPACK FOOTER //
// ./src/store/error/ErrorActionsEnums.js